'use strict';

const animate = ( step, timeline, oppositeDirection ) => {
    // Move the step out of the screen
    timeline.to( step, {
        position: 'absolute',
        yPercent: oppositeDirection ? 100 : -100,
    }, 0 ).addLabel('end_of_previous_step', '>');

    // Parallax effect on the answers
    $(step).find('.step__answers .step__answer').each((index, answer) => {
        timeline.to( answer, { y: 40 * index }, '<' );
    });

    // Remove step
    if (oppositeDirection) {
        timeline.call( () => { $(step).remove(); }, null, '>' );
    }

    // Hide step after animation
    timeline.set( step, {
        ariaHidden: 'true',
        display: 'none',
        duration: 0,
    }, 'end_of_previous_step' );
};

module.exports = {
    animate
};
